import {
  Column,
  UseFiltersColumnOptions,
  UseSortByColumnOptions,
  Cell,
  CellProps,
  Row,
  TableInstance,
  ColumnWithLooseAccessor,
  ColumnInstance,
  SortByFn,
  IdType,
} from 'react-table';

export {
  Column,
  Cell,
  CellProps,
  Row as TableRow,
  TableInstance,
  ColumnWithLooseAccessor,
  ColumnInstance,
  SortByFn,
  IdType,
};

export type TableRowDataType = Record<string, unknown>;

export enum TooltipTitleType {
  /**
   * no tooltip to be shown
   */
  None,

  /**
   * use the default tooltip from react-table
   */
  Default,
}

export type CustomColumnFields = {
  fitToContent?: boolean;
  tooltipTitle?: TooltipTitleType | string;
};

export type TableColumn<TableRowData extends TableRowDataType> = Column<TableRowData> &
  Partial<UseSortByColumnOptions<TableRowData>> &
  Partial<UseFiltersColumnOptions<TableRowData>> &
  CustomColumnFields;
